import Hamburger from './Hamburger';

export default Hamburger;



// WEBPACK FOOTER //
// ./src/components/Header/components/Hamburger/index.tsx